import { render, staticRenderFns } from "./ReportsCreditDebit.vue?vue&type=template&id=5835a8ca"
import script from "./ReportsCreditDebit.vue?vue&type=script&lang=js"
export * from "./ReportsCreditDebit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports